import { Form, Input, Select } from 'antd';
import styled from 'styled-components';

import { SvgIcon } from '../../../components/svg-icon';
import { ButtonWithLoader } from '../../../components/ui-helpers';
import { AvatarImage } from '../../../components/avatar/styled-components';
import { Select as SelectWithContext } from '../../../components/popovers';


const FormItem = Form.Item;
const { Option } = Select;

export const SelectDropdown = styled.div`
  .ant-select-dropdown-menu-item {
    padding: 10px 0 0 10px;
  }
`;

export const StyledFormItem = styled(FormItem)`
  label {
    color: ${({ theme }) => theme.colors.mainDark};
  }
  
  .ant-form-item-label {
    line-height: 2;
  }
`;

export const StyledInput = styled(Input)`
  font-size: 14px;
`;

export const TaskInfoWrap = styled.div`
  margin-top: 18px;
`;

export const SelectS = styled(SelectWithContext)`
  font-size: 14px;
`;

export const StyledOption = styled(Option)`
  display: flex;
  flex-direction: row;
`;

export const UserImageWrap = styled(AvatarImage)`
  margin-right: 15px;
`;

export const ButtonWrap = styled.div`
  margin-top: 20px;
  text-align: center;

  ${ButtonWithLoader} {
    height: 40px;
    max-width: 160px;
    border-radius: 30px;
  }
`;

export const FieldWrapper = styled.div`
  position: relative;
`;

export const OptionContainer = styled.div`
  margin-bottom: 6px;
`;

export const BoldS = styled.span`
  font-weight: 500;
`;

export const ContactsS = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContactS = styled.div`
  background: #FFEADB;
  padding: 0 10px;
  border-radius: 20px;
  border: 1px solid #FD740D;
  margin: 0 3px;
`;

export const OptionHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin: 7px 0;
  & > :first-child {
    margin-right: 20px;
  }
`;

export const OptionRow = styled.div`
  margin: 7px 0;
`;

export const RequestLink = styled.a`
  margin-left: auto;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.fontTangerine};
    &:hover,
    &:focus {
      color: ${({ theme }) => theme.colors.fontTangerine};
    }
`;

export const LinkIcon = styled(SvgIcon)`
  margin-bottom: -1px;
  margin-left: 4px;
`;

export const AssignInfo = styled.div`
  max-width: 220px;
  font-weight: 400;
  word-wrap: break-word;
`;

export const SvgWrapper = styled.span`
  position: absolute;
  cursor: pointer;
  height: 19px;
  padding: 4px;
  z-index: 2;
  left: 62px;
  top: 2px;
`;



// WEBPACK FOOTER //
// ./src/modals/tasks-modal/task-form/styles.js